window.addEventListener("load", function () {
  if ($("#swiperEvent").length > 0) {
    // Initialize thumbnail pagination elements first
    const thumbnailItems = document.querySelectorAll('.thumbnail-item');

    // Function to update thumbnail pagination
    function updateThumbnailPagination(activeIndex) {
      thumbnailItems.forEach((thumbnail, index) => {
        if (index === activeIndex) {
          thumbnail.classList.add('active');
        } else {
          thumbnail.classList.remove('active');
        }
      });
    }

    const swiper = new Swiper("#swiperEvent", {
      navigation: {
        nextEl: ".swiper-button-next--swiperEvent",
        prevEl: ".swiper-button-prev--swiperEvent",
      },
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 20,
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      on: {
        slideChange: function () {
          updateThumbnailPagination(this.realIndex);
        },
      },
    });

    // Set initial active thumbnail
    if (thumbnailItems.length > 0) {
      thumbnailItems[0].classList.add('active');
    }

    // Add click event to thumbnails
    thumbnailItems.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', function () {
        swiper.slideToLoop(index);
        updateThumbnailPagination(index);
      });
    });
  }
});